const translation = {}

export default translation
